/**
 * searchr.ts - Searchr (Search System) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const searchrModule = {
  id: 'data-searchr',
  name: 'Search System',
  icon: '🔎',
  category: 'modules',
  order: 31,
  
  packageInfo: {
    name: '@opcentral/searchr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Universal search system with full-text search and indexing',
    status: 'in-progress',
    implementationProgress: 70,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      '@opcentral/cachr': '*'
    },
    keywords: ['search', 'fulltext', 'indexing', 'query'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableFullTextSearch: {
      type: 'boolean',
      label: 'Enable Full-Text Search',
      description: 'Use full-text search indexing',
      defaultValue: true
    },
    
    fuzzySearch: {
      type: 'boolean',
      label: 'Fuzzy Search',
      description: 'Allow approximate matching',
      defaultValue: true
    },
    
    maxResults: {
      type: 'number',
      label: 'Max Search Results',
      description: 'Maximum number of results to return',
      defaultValue: 100,
      min: 10,
      max: 1000
    },
    
    highlightMatches: {
      type: 'boolean',
      label: 'Highlight Matches',
      description: 'Highlight search terms in results',
      defaultValue: true
    }
  }
};

export default searchrModule;
